module.exports = __webpack_public_path__ + "84cf7e19c5c908facf9e4a97aeddf466.fbx";